<!-- BEGIN: Topbar -->
<div class="kt-header__topbar">
  @if (isQuickThemeSelectEnabled) {
    <div id="kt_theme_selection_panel_toggle" class="kt-header__topbar-item dropdown">
      <div class="kt-header__topbar-wrapper">
        <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
          <i class="flaticon-interface-7"></i>
        </span>
      </div>
    </div>
  }
  @if (languages.length > 1) {
    <div dropdown class="kt-header__topbar-item dropdown dropdown-language">
      <div dropdownToggle class="kt-header__topbar-wrapper dropdown-toggle" data-toggle="dropdown"
        data-offset="30px,0px" aria-expanded="true" aria-haspopup="true">
        <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
          <i [class]="currentLanguage.icon"></i>
        </span>
      </div>
      <div *dropdownMenu
        class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg"
        [attr.aria-label]="l('Languages')">
        <ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
          @for (language of languages; track language) {
            <li class="kt-nav__item">
              <a class="kt-nav__link" (click)="changeLanguage(language.name)">
                <span class="kt-nav__link-icon">
                  <i [class]="language.icon"></i>
                </span>
                <span class="kt-nav__link-text">
                  {{language.displayName}}
                </span>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  }

  <div headerNotifications class="kt-header__topbar-item dropdown" dropdown id="header_notification_bar"></div>
  <div class="kt-header__topbar-item kt-header__topbar-item--user ng-star-inserted  dropdown" dropdown
    placement="bottom-right">
    <div class="kt-header__topbar-wrapper dropdown-toggle" data-toggle="dropdown"
      aria-expanded="false" aria-haspopup="true" dropdownToggle>
      <div class="kt-header__topbar-user">
        @if (isImpersonatedLogin) {
          <i class="fa fa-reply kt-font-danger mr-2"></i>
        }
        <span class="kt-header__topbar-username kt-hidden-mobile">
          @if (isMultiTenancyEnabled) {
            <span class="tenancy-name">{{tenancyName}}\</span>
            }{{userName}}
          </span>
          @if (profilePicture) {
            <img class="header-profile-picture m--img-rounded m--marginless m--img-centered"
              alt="Pic" [src]="profilePicture">
          }
        </div>
      </div>
      <div *dropdownMenu
        class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
        x-placement="bottom-right"
        style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(1253px, 64px, 0px);">
        <div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
          [ngStyle]="{ 'background': 'url(' + appRootUrl() + 'assets/common/images/user-card-bg.jpg)', 'background-size': 'cover'}">
          <div class="kt-user-card__avatar">
            <img class="" alt="Pic" [src]="profilePicture">
          </div>
          <div class="kt-user-card__name text-color-reliable">
            @if (isMultiTenancyEnabled) {
              <span class="tenancy-name">{{tenancyName}}\</span>
              }{{userName}}
            </div>
          </div>
          <div class="kt-notification user-profile-menu">
            @if (isImpersonatedLogin) {
              <a href="javascript:;" class="kt-notification__item"
                (click)="backToMyAccount()">
                <div class="kt-notification__item-icon">
                  <i class="fa fa-reply kt-font-danger"></i>
                </div>
                <div class="kt-notification__item-details">
                  <div class="kt-notification__item-title kt-font-bold">
                    <span>
                      {{"BackToMyAccount" | localize}}
                    </span>
                  </div>
                </div>
              </a>
            }
            <a href="javascript:;" class="kt-notification__item" (click)="showLoginAttempts()">
              <div class="kt-notification__item-icon">
                <i class="flaticon-list"></i>
              </div>
              <div class="kt-notification__item-details">
                <div class="kt-notification__item-title kt-font-bold">
                  <span>
                    {{"LoginAttempts" | localize}}
                  </span>
                </div>
              </div>
            </a>
            <a href="javascript:;" class="kt-notification__item" (click)="changeProfilePicture()">
              <div class="kt-notification__item-icon">
                <i class="flaticon-profile-1"></i>
              </div>
              <div class="kt-notification__item-details">
                <div class="kt-notification__item-title kt-font-bold">
                  <span>
                    {{"ChangeProfilePicture" | localize}}
                  </span>
                </div>
              </div>
            </a>
            <div class="kt-notification__custom">
              <a (click)="logout()" class="btn btn-label-brand btn-sm btn-bold btn-primary text-color-transparent">{{"Logout" | localize}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Topbar -->
